import APIClient from '@/shared/http/clients/api'

const resourceName = 'FuncaoObra'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)

const WorkPositionRepository = {
  GetAll
}
export default WorkPositionRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/workPosition.js